/* Frontend contract for casino game classification + tile geometry.

   The BACKEND is the source of truth for classification: every provider game carries a
   normalized `is_live_dealer` flag (see backend/casino_providers/classification.py). These
   helpers just read it consistently so no component re-derives "is this a live dealer?"
   from a raw provider "Live" label — JackTop's "Live" bucket is RNG table games, not human
   dealers (JackTop QA, 2026-10). */

// A game is a live-dealer game ONLY when the normalized catalog says so.
export function isLiveDealer(game) {
  return Boolean(game && game.is_live_dealer);
}

/* Tile aspect ratio. Provider art (e.g. JackTop) ships square (1:1), so a square tile with
   object-cover crops nothing — no cut-off dealer heads. Native live tables use a landscape
   card; everything else is the 3:4 portrait original. Never a free/stretched ratio. */
export function tileAspectClass({ square = false, live = false } = {}) {
  if (square) return "aspect-square";
  if (live) return "aspect-[16/10]";
  return "aspect-[3/4]";
}
